var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "25px",
    height: "36px",
    viewBox: "0 0 25 36",
    enableBackground: "new 0 0 25 36",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#E40127",
    d: "M13.692,0.244c0.464,0.173,0.96,0.164,1.436,0.27 c2.811,0.626,5.15,2.038,6.989,4.243c1.498,1.797,2.417,3.865,2.749,6.197c0.368,2.59-0.018,5.055-1.198,7.379 c-0.694,1.367-1.558,2.638-2.351,3.949c-2.55,4.209-5.106,8.412-7.654,12.621c-0.211,0.348-0.442,0.656-0.804,0.854 c-0.115,0-0.229,0-0.345,0c0-5.592,0-11.184,0-16.774c0.513-0.063,1.031-0.089,1.536-0.216c2.415-0.598,4.224-2.593,4.628-5.116 c0.378-2.36-0.772-4.86-2.805-6.159c-1.028-0.658-2.159-0.943-3.359-1.016c0-2.078,0-4.154,0-6.231 C12.906,0.244,13.3,0.244,13.692,0.244z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FC013A",
    d: "M12.515,18.982c0,5.59,0,11.182,0,16.774 c-0.094,0-0.187,0-0.279,0c-0.352-0.195-0.576-0.5-0.783-0.84c-3.135-5.143-6.264-10.287-9.424-15.414 c-1.531-2.485-2.227-5.154-1.926-8.058c0.27-2.597,1.27-4.894,2.98-6.873c1.491-1.725,3.326-2.943,5.479-3.68 c0.866-0.296,1.759-0.468,2.666-0.58c0.063-0.008,0.142,0.021,0.176-0.068c0.37,0,0.74,0,1.11,0c0,2.077,0,4.154,0,6.231 c-0.543,0.028-1.086,0.071-1.608,0.229C8.558,7.412,7.013,8.943,6.45,11.329c-0.541,2.304,0.112,4.323,1.82,5.967 C9.447,18.428,10.895,18.933,12.515,18.982z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FEFDFD",
    d: "M12.515,18.982c-1.62-0.049-3.067-0.554-4.244-1.687 c-1.708-1.644-2.361-3.663-1.82-5.967c0.563-2.386,2.107-3.917,4.456-4.625c0.522-0.157,1.065-0.2,1.608-0.229 c1.2,0.073,2.331,0.358,3.359,1.016c2.032,1.298,3.183,3.799,2.805,6.159c-0.404,2.523-2.213,4.519-4.628,5.116 C13.546,18.893,13.027,18.918,12.515,18.982z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoint);
export default __webpack_public_path__ + "static/media/point.11d9b5d2ea109e10c236e56644f1d9ff.svg";
export { ForwardRef as ReactComponent };